export const SWITCH_IPV6_ACL_SECTION_EVENT =
	'canvas-agent:switch-ipv6-acl:section';
export const SWITCH_IPV6_ACL_FOCUS_EVENT =
	'canvas-agent:switch-ipv6-acl:focus';
export const SWITCH_IPV6_ACL_FILTER_EVENT =
	'canvas-agent:switch-ipv6-acl:filter';
export const SWITCH_IPV6_ACL_CREATE_MODAL_EVENT =
	'canvas-agent:switch-ipv6-acl:create-modal';
export const SWITCH_IPV6_ACL_DELETE_MODAL_EVENT =
	'canvas-agent:switch-ipv6-acl:delete-modal';
export const SWITCH_IPV6_ACL_ADD_ACE_EVENT =
	'canvas-agent:switch-ipv6-acl:add-ace';
export const SWITCH_IPV6_ACL_EDIT_ACE_EVENT =
	'canvas-agent:switch-ipv6-acl:edit-ace';
export const SWITCH_IPV6_ACL_DELETE_ACE_EVENT =
	'canvas-agent:switch-ipv6-acl:delete-ace';
